import React, { Component, Fragment } from 'react'
import { FormControlLabel, Grid, Box, Typography, FormHelperText, Checkbox, TextField } from '@material-ui/core';
import { withStyles, createStyles, WithStyles } from '@material-ui/core/styles';
import ApplicationValue from '../model/application-value';
import { Alert, AlertTitle } from '@material-ui/lab';

const styles = (() => createStyles({
    label: {
        alignItems: 'flex-start'
    },
    checkbox: {
        paddingTop: 0,
    },
}
));

interface IPermissionsProperties extends WithStyles<typeof styles> {
    disabled: boolean | undefined;
    onDataChange: any;
    data: ApplicationValue[];
    renderButtons: any;
    nextClick: any;
    prevClick: any;
}

const PermissionsForm = withStyles(styles)(
    class extends Component<IPermissionsProperties, any> {
        oswiadczenie_1 = (<span>[*] Oświadczam, że zapoznałem/am się, zrozumiałem/am i akceptuję treść <a target="_blank" rel="noopener noreferrer" href="https://online.sagabrokers.pl/files/general/Regulamin_świadczenia_usług_drogą_elektroniczną_rolne.pdf">regulaminu świadczenia usług drogą elektroniczną.</a></span>);
        oswiadczenie_2 = (<span>[*] Oświadczam, że została mi udostępniona i zapoznałem/am się z <a target="_blank" rel="noopener noreferrer" href="https://online.sagabrokers.pl/files/general/Informacja_Administratora_danych_osobowych_SAGA_rolne.pdf">informacją o przetwarzaniu danych osobowych.</a></span>)
        oswiadczenie_3 = (<span>[*] Oświadczam, że zapoznałem/am się, z <a target="_blank" rel="noopener noreferrer" href="https://sagabrokers.pl/informacja-o-dystrybutorze/">informacją o dystrybutorze.</a></span>)
        oswiadczenie_4 = `[*] W związku z brzmieniem art. 10 ustawy z dnia 18 lipca 2002 r. o świadczeniu usług drogą elektroniczną, wyrażam zgodę na przesyłanie przez SAGA Brokers Sp. z o.o. informacji handlowych, w tym propozycji i ofert ubezpieczenia, za pomocą środków komunikacji elektronicznej, w szczególności na podany powyżej adres mailowy. Zgoda ta jest wymagana na podstawie z art. 10 ust. 1 ustawy.`;
        oswiadczenie_5 = `[*] Udzielam pełnomocnictwa Pierwszemu Polskiemu Domowi Brokerskiemu SAGA Brokers Sp. z o.o. z siedzibą w Poznaniu do wykonywania dystrybucji ubezpieczeń (czynności brokerskich w zakresie ubezpieczeń), czyli doradzania, proponowania lub wykonywania innych czynności przygotowawczych zmierzających do zawarcia umów ubezpieczenia, zawierania umów ubezpieczenia w moim imieniu lub na moją rzecz, udzielania pomocy w administrowaniu umowami ubezpieczenia i ich wykonywaniu, także w sprawach o odszkodowanie lub świadczenie oraz do składania oświadczeń woli w zakresie zawarcia umów ubezpieczenia zgodnych ze składanymi przeze mnie wnioskami.`;
        oswiadczenie_6 = `[*] Upoważniam Pierwszy Polski Dom Brokerski SAGA Brokers Sp. z o.o. do pozyskiwania w moim imieniu od zakładów ubezpieczeń wszelkich informacji dotyczących złożonych przeze mnie wniosków ubezpieczeniowych, umów ubezpieczenia składanych lub zawieranych za jej pośrednictwem, których jestem lub będę stroną, w tym o dokonanych płatnościach . Wyrażam zgodę na przekazanie przez zakłady ubezpieczeń danych osobowych, o których mowa wyżej, Pierwszemu Polskiemu Domowi Brokerskiemu SAGA Brokers Sp. z o.o. i na przetwarzanie przez Pierwszy Dom Brokerski SAGA Brokers Sp. z o.o. tych danych w celu realizacji obowiązków związanych z wykonywaniem usługi pośrednictwa. Udzielenie niniejszego upoważnienia jest dobrowolne ale jest warunkiem koniecznym złożenia wniosku ubezpieczeniowego przez niniejszy portal. Zgoda może być wycofana w każdym czasie przez skierowanie oświadczenia na adres email: odo@sagabrokers.pl. Wycofanie upoważnienia nie wpływa na zgodność z prawem przetwarzania dokonanego na jego podstawie przed jego wycofaniem, może natomiast uniemożliwić zawarcie umowy ubezpieczenia.`;

        constructor(props: IPermissionsProperties) {
            super(props);

            var form: any = {};
            props.data.forEach((element) => {
                Object.assign(form, { [element.key]: element });
            });

            if (!form.oswiadczenie_1)
                form.oswiadczenie_1 = new ApplicationValue('oswiadczenie_1', '', null);
            if (!form.oswiadczenie_2)
                form.oswiadczenie_2 = new ApplicationValue('oswiadczenie_2', '', null);
            if (!form.oswiadczenie_3)
                form.oswiadczenie_3 = new ApplicationValue('oswiadczenie_3', '', null);
            if (!form.oswiadczenie_4)
                form.oswiadczenie_4 = new ApplicationValue('oswiadczenie_4', '', null);
            if (!form.oswiadczenie_5)
                form.oswiadczenie_5 = new ApplicationValue('oswiadczenie_5', '', null);
            if (!form.oswiadczenie_6)
                form.oswiadczenie_6 = new ApplicationValue('oswiadczenie_6', '', null);
            if (!form.oswiadczenie_info)
                form.oswiadczenie_info = new ApplicationValue('oswiadczenie_info', '', null);


            this.state = {
                form: form,
                errors: [],
                errorPanelVisible: false
            };

        }

        componentDidMount() {
            window.scrollTo(0, 0)
        }

        handlePermissionChange = (event: any) => {

            let av: ApplicationValue;
            av = this.state.form[event.target.name];
            av.value = event.target.value;

            this.setState({
                form: {
                    ...this.state.form,
                    [event.target.name]: av
                }
            });
        }

        validateForm = (): boolean => {
            const state = this.state.form;

            var result = Object.keys(state).filter((key) => {
                return key !== 'oswiadczenie_info' && state[key].value === ""
            });
            this.setState({ errors: result, errorPanelVisible: result.length > 0 });

            return result.length === 0;
        }

        getData = (): ApplicationValue[] => {
            let apk: ApplicationValue[] = [];
            for (let [, value] of Object.entries(this.state.form)) {
                if ((value as ApplicationValue).value !== '')
                    apk.push(value as ApplicationValue);
            }
            return apk;
        }

        next = () => {
            let result = this.validateForm();
            if (result) {
                this.props.onDataChange(this.getData(), result);
                this.props.nextClick();
            } else {
                window.scrollTo(0, 0);
            }
        }

        previous = () => {
            this.props.onDataChange(this.getData());
            this.props.prevClick();
        }

        hasError = (fieldName: string): boolean => {
            return this.state.errors.includes(fieldName)
        }

        render() {
            const { classes } = this.props as any;
            return (
                <Fragment>
                    <Box marginBottom={3}>
                        <Typography variant="h5" align="center" gutterBottom={true}>Oświadczenia</Typography>
                    </Box>
                    {
                        this.state.errors.length > 0 ?
                            <>
                                <Alert severity="error">
                                    <AlertTitle>Uwaga</AlertTitle>
                                    <p>Oświadczenia zaznaczone na czerwono są obowiązkowe. Zaznacz je, aby przejść dalej.</p>
                                </Alert>
                                <Typography variant="h5" gutterBottom={true}>&nbsp;</Typography>
                            </>
                            : null

                    }

                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <FormHelperText error={this.hasError('oswiadczenie_1')}>
                                <FormControlLabel
                                    className={classes.label}
                                    control={<Checkbox className={classes.checkbox} disabled={this.props.disabled} id="oswiadczenie_1" name="oswiadczenie_1" checked={this.state.form.oswiadczenie_1.value === 'true'} onChange={this.handlePermissionChange} value="true" />}
                                    label={this.oswiadczenie_1}
                                    value="start" labelPlacement="end"
                                />
                            </FormHelperText>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormHelperText error={this.hasError('oswiadczenie_2')}>
                                <FormControlLabel
                                    className={classes.label}
                                    control={<Checkbox className={classes.checkbox} disabled={this.props.disabled} id="oswiadczenie_2" name="oswiadczenie_2" checked={this.state.form.oswiadczenie_2.value === 'true'} onChange={this.handlePermissionChange} value="true" />}
                                    label={this.oswiadczenie_2}
                                    value="start" labelPlacement="end"
                                />
                            </FormHelperText>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormHelperText error={this.hasError('oswiadczenie_3')}>
                                <FormControlLabel
                                    className={classes.label}
                                    control={<Checkbox className={classes.checkbox} disabled={this.props.disabled} id="oswiadczenie_3" name="oswiadczenie_3" checked={this.state.form.oswiadczenie_3.value === 'true'} onChange={this.handlePermissionChange} value="true" />}
                                    label={this.oswiadczenie_3}
                                    value="start" labelPlacement="end"
                                />
                            </FormHelperText>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormHelperText error={this.hasError('oswiadczenie_4')}>
                                <FormControlLabel
                                    className={classes.label}
                                    control={<Checkbox className={classes.checkbox} disabled={this.props.disabled} id="oswiadczenie_4" name="oswiadczenie_4" checked={this.state.form.oswiadczenie_4.value === 'true'} onChange={this.handlePermissionChange} value="true" />}
                                    label={this.oswiadczenie_4}
                                    value="start" labelPlacement="end"
                                />
                            </FormHelperText>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormHelperText error={this.hasError('oswiadczenie_5')}>
                                <FormControlLabel
                                    className={classes.label}
                                    control={<Checkbox className={classes.checkbox} disabled={this.props.disabled} id="oswiadczenie_5" name="oswiadczenie_5" checked={this.state.form.oswiadczenie_5.value === 'true'} onChange={this.handlePermissionChange} value="true" />}
                                    label={this.oswiadczenie_5}
                                    value="start" labelPlacement="end"
                                />
                            </FormHelperText>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormHelperText error={this.hasError('oswiadczenie_6')}>
                                <FormControlLabel
                                    className={classes.label}
                                    control={<Checkbox className={classes.checkbox} disabled={this.props.disabled} id="oswiadczenie_6" name="oswiadczenie_6" checked={this.state.form.oswiadczenie_6.value === 'true'} onChange={this.handlePermissionChange} value="true" />}
                                    label={this.oswiadczenie_6}
                                    value="start" labelPlacement="end"
                                />
                            </FormHelperText>
                        </Grid>
                        <Grid item xs={12} sm={12} spacing={4}>
                            <TextField
                                id="oswiadczenie_info"
                                name="oswiadczenie_info"
                                label="Dodatkowe informacje dla brokera"
                                multiline
                                fullWidth
                                rows={4}
                                value={this.state.form.oswiadczenie_info.value}
                                variant="outlined"
                                onChange={this.handlePermissionChange}
                            />
                        </Grid>
                    </Grid>
                    {this.props.renderButtons({ caption: 'Dalej', click: this.next }, { caption: 'Wstecz', click: this.previous })}
                </Fragment>
            )
        }
    }
)

export default PermissionsForm;
